import React, { Component } from "react";
import Dualbox from '../../../../common/components/UI/DualListBox/DualListBox';
import { cloneDeep } from "lodash";
import {
  withStyles,
  CardHeader,
  Card,
  CardContent,
  Typography,
  Grid,
  Avatar,
  FormControl,
  FormGroup,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  FormHelperText,
  Tooltip,
} from "@material-ui/core";
import HelpIcon from "@material-ui/icons/Help";

import { withTranslation } from "react-i18next";
import ActionButtons from "../../../../common/components/UI/ActionButtons/ActionButtons";
import CustomButton from "../../../../common/components/UI/Button/Button";
import ReactSelect from "../../../../common/components/UI/Select/ReactSelect";
import ReactToggle from "../../../../common/components/UI/ToggleSwitch/ReactToggle";
import DebouncedTextField from "../../../../common/components/UI/TextField/DebouncedTextField";
import {
  handleChangeDualBox,
  moveAll,
} from "../../../../common/components/handlerFunctions";
import DebouncedNumericPicker from "../../../../common/components/UI/DebouncedNumericPicker";
import DualListBox from "../../../../common/components/UI/DualListBox/DualListBox";
import HoursMinutesPicker from "../../../../common/components/UI/HoursMinutesPicker/HoursMinutesPicker";
import { VTO_TYPES } from "../../../constants";
import {
  RequestTypes,
  VtoCoverageRequiredEdge,
  RequestSubtypes,
  VoluntaryTimeOffType,
  AdminSidePanelActionNames,
  ConfigurationSetWarningCodes,
  TorCreationType,
  VtoPaycodeCreationType,
} from "../../../Enums";
import { getRequestSubTypeList, getTorCreationTypeOptions, getVtoPaycodeCreationTypeOptions } from "../../../Enums/Helpers/LabellingHelper";
import TimeOffRequestWarning from "./TimeOffRequestWarning";
import CustomTagsDisplay from "./CustomTagsDisplay";

import {
  vtoCoverageRequiredEdgesOptions,
  styles,
  HoursMinutesPickerStyles,
  RESET_ADMIN_SETTING_FORM_VALUES,
  getBreRuleSetListOptions,
  getVtoTypes,
  getIsAllowProposalWithOfferTooltipOnDisabled,
  getIsAllowMultipleRequestsTooltipOnDisabled,
  getGroupedShiftSwapTooltipOnDisabled,
  getIsKeepEmployeeWorkRuleTooltipOnDisabled,
  getEnableShiftSwapEmployeePreferencesTooltipOnDisabled,
} from "./Form.service";
import { createCopyName } from "../../../auxilaries";
import PartialShiftSection from "./PartialShiftSection";
import RequestPeriodOverrideDropdown from './RequestPeriodOverrideDropdown';
import DurationInput from "../../RuleSet/RuleSetEdit/Step2-BreakRuleSection/DurationInput";
import { WarningIconWithTooltip } from "../../../../common-client2/src/components";

/** @typedef {{ label: string; value: string|number }} ListItem */

class Form extends Component {
  constructor(props) {
    super(props);

    /** @type {import('./Form.service').FormStateProps} */
    this.state = {
      actionType: { label: "To Cover", value: 0 },
      autoApproval: false,
      awardingRule: "",
      breRules: [{ value: "BRE", label: "BRE" }],
      breRuleSet: "",
      breRulesOptions: [{ value: "BRE", label: "BRE" }],
      createOpenShift: false,
      creationHyperFindQuery: "",
      dataview: this.findItem(props.dataviewList, null, "value"),
      dataviewColumns: {
        included: [],
        excluded: [],
      },
      description: "",
      editMode: false,
      enablePartialShifts: false,
      isAutoExpiryTimeOnPrivateOfferEnabled: false,
      autoExpiryTimeOnPrivateOffer: null,
      isTimeOffRequestCreationAutoApproval: false,
      isAllowToCoverApprovalWhenPtoIsRejected: false,
      enableShiftSwapEmployeePreferences: false,
      errorName: false,
      groupedShiftSwap: false,
      isAllowMultipleRequests: false,
      isAllowProposalWithOffer: false,
      isAllowSignUpPeriodWithOpenShift: true,
      isAllowSignUpPeriodWithShiftSwapShift: true,
      isAllowSignUpPeriodWithToCoverShift: true,
      isBlockOsOverlap: false,
      isUsedAdminSetting: false,
      isPartialOnlyOnEdges: false,
      isSubmitable: false,
      isShowTimeOffRequestWarning: false,
      managementHyperFindQuery: "",
      minimumPartialShiftBalanceDuration: 0,
      minimumPartialShiftDuration: 0,
      minimumShiftBalanceDuration: 0,
      minutesToBlockOs: 0,
      multiplePartial: false,
      isAllowPartialOfPartial: false,
      name: "",
      payCode: "",
      prevState: {},
      requestSubtype: null,
      selectedTimePeriodRationOptions: [],
      segmentTag: this.findItem(props.segmentTagsList, null, "value"),
      showButtons: false,
      template1: this.findItem(props.genericNotificationList, null, "value"),
      template2: this.findItem(props.genericNotificationList, null, "value"),
      template3: this.findItem(props.genericNotificationList, null, "value"),
      template4: this.findItem(props.genericNotificationList, null, "value"),
      template5: this.findItem(props.genericNotificationList, null, "value"),
      template6: this.findItem(props.genericNotificationList, null, "value"),
      template7: this.findItem(props.genericNotificationList, null, "value"),
      template8: this.findItem(props.genericNotificationList, null, "value"),
      template9: this.findItem(props.genericNotificationList, null, "value"),
      template10: this.findItem(props.genericNotificationList, null, "value"),
      template11: this.findItem(props.genericNotificationList, null, "value"),
      template12: this.findItem(props.genericNotificationList, null, "value"),
      template13: this.findItem(props.genericNotificationList, null, "value"),
      template14: this.findItem(props.genericNotificationList, null, "value"),
      template15: this.findItem(props.genericNotificationList, null, "value"),
      template16: this.findItem(props.genericNotificationList, null, "value"),
      timePeriodRatioOptions: props.timePeriodRatioOptions.map((option) => {
        return { ...option, checked: false };
      }),
      vtoTypes: VTO_TYPES,
      vtoCoverageRequiredEdgesOptions: vtoCoverageRequiredEdgesOptions,
      vtoCoverageRequiredEdgeSelected: VtoCoverageRequiredEdge.noPreference,
      isVtoOverlapChecked: false,
      vtoPaycodeCreationType: null,
      workRule: this.findItem(props.workRuleList, null, "value"),
      maxAllowedPartial: null,
      privateEmployeeSource: null,
      isKeepEmployeeWorkRule: false,
      isOverwriteRequestPeriodNumberOfMonthsInFuture: false,
      overwriteRequestPeriodNumberOfMonthsInFuture: null,
      workRules: {
        included: props.workRuleList.filter(x => x.label !== "None"),
        excluded: [],
      },
      isVtoPaycodeBreakRuleEnabled: false,
      vtoPaycodeBreakRule: null,
      segmentTagsFilter: {
        included: [...props.segmentTagsList.filter(x => x.id !== null)],
        excluded: [],
      },
      torCreationType: getTorCreationTypeOptions().find(x => x.value === TorCreationType.None),
    };
  }

  componentWillMount = () => {
    const {
      action,
      actionTypeList,
      awardingRulesList,
      breRuleSetList,
      dataviewList,
      hyperFindList,
      payCodeList,
      segmentTagsList,
      settingList,
      settingSelected,
      workRuleList,
      t,
      privateEmployeeSources,
      breakRuleList,
    } = this.props;

    const isEdit = action === AdminSidePanelActionNames.Edit;
    const isDuplicate = action === AdminSidePanelActionNames.Duplicate;
    const isView = action === AdminSidePanelActionNames.View;

    if (isEdit || isDuplicate || isView) {
      let name = "";
      let isUsedAdminSetting = false;

      if (isEdit) {
        name = settingSelected.name;
        isUsedAdminSetting = settingSelected.isUsedAdminSetting;
      } else {
        name = createCopyName(
          settingSelected.name,
          settingList.map((x) => x.name),
          t("common2:copyOf")
        );
      }

      const dataviewColumns = {
        included: [],
        excluded: [],
      };

      if (settingSelected.dataviewId && settingSelected.dataviewId !== 0) {
        const dataviewFound = this.findItem(
          dataviewList,
          settingSelected.dataviewId,
          "id"
        );

        if (dataviewFound) {
          for (const field of dataviewFound.fields) {
            if (settingSelected.dataviewDisplayedCols.includes(field.key)) {
              dataviewColumns.excluded.push({
                ...field,
                value: field.key,
              });
            } else {
              dataviewColumns.included.push({
                ...field,
                value: field.key,
              });
            }
          }
        }
      }

      let vtoTypes = this.state.vtoTypes.map((type) => ({
        ...type,
        checked: settingSelected.voluntaryTimeOffTypes?.includes(type.value),
      }));

      let timePeriodRatioOptions = this.state.timePeriodRatioOptions.map(
        (option) => ({
          ...option,
          checked: settingSelected.timePeriodRatioOptions?.includes(option.id),
        })
      );

      const stateFromSelectedSetting = {
        actionType: this.findItem(
          actionTypeList,
          settingSelected.actionType,
          "value"
        ),
        autoApproval: settingSelected.autoApproval,
        awardingRule: this.findItem(
          awardingRulesList,
          settingSelected.awardingRuleId,
          "id"
        ),
        breRuleSet:
          settingSelected.breRuleSetId === null
            ? this.findItem(breRuleSetList, "None", "name")
            : this.findItem(
              breRuleSetList,
              settingSelected.breRuleSetId,
              "value"
            ),
        createOpenShift: settingSelected.createOpenShift,
        creationHyperFindQuery: this.findItem(
          hyperFindList,
          settingSelected.creationHyperfindId,
          "value"
        ),
        dataview:
          settingSelected.dataviewId === 0
            ? this.findItem(dataviewList, "None", "name")
            : this.findItem(dataviewList, settingSelected.dataviewId, "id"),
        dataviewColumns: dataviewColumns,
        description: settingSelected.description,
        enablePartialShifts: settingSelected.enablePartialShifts,
        isAutoExpiryTimeOnPrivateOfferEnabled: settingSelected.isAutoExpiryTimeOnPrivateOfferEnabled,
        autoExpiryTimeOnPrivateOffer: settingSelected.autoExpiryTimeOnPrivateOffer ?? null,
        isTimeOffRequestCreationAutoApproval:
          settingSelected.isTimeOffRequestCreationAutoApproval,
        isAllowToCoverApprovalWhenPtoIsRejected:
          settingSelected.isAllowToCoverApprovalWhenPtoIsRejected,
        enableShiftSwapEmployeePreferences:
          settingSelected.enableShiftSwapEmployeePreferences,
        groupedShiftSwap: settingSelected.groupedShiftSwap,
        isAllowMultipleRequests: settingSelected.isAllowMultipleRequests,
        isAllowProposalWithOffer: settingSelected.isAllowProposalWithOffer,
        isAllowSignUpPeriodWithOpenShift:
          settingSelected.isAllowSignUpPeriodWithOpenShift,
        isAllowSignUpPeriodWithShiftSwapShift:
          settingSelected.isAllowSignUpPeriodWithShiftSwapShift,
        isAllowSignUpPeriodWithToCoverShift:
          settingSelected.isAllowSignUpPeriodWithToCoverShift,
        isBlockOsOverlap: settingSelected.isBlockOsOverlap,
        isUsedAdminSetting: isUsedAdminSetting,
        isPartialOnlyOnEdges: settingSelected.isPartialOnlyOnEdges,
        managementHyperFindQuery: this.findItem(
          hyperFindList,
          settingSelected.managementHyperfindId,
          "value"
        ),
        minimumPartialShiftBalanceDuration:
          settingSelected.minimumPartialShiftBalanceDuration || 0,
        minimumPartialShiftDuration:
          settingSelected.minimumPartialShiftDuration,
        minimumShiftBalanceDuration:
          settingSelected.minimumShiftBalanceDuration || 0,
        minutesToBlockOs: settingSelected.minutesToBlockOs,
        multiplePartial: settingSelected.multiplePartial,
        isAllowPartialOfPartial: settingSelected.isAllowPartialOfPartial,
        name: name,
        payCode:
          settingSelected.vtoPayCode === 0
            ? this.findItem(payCodeList, "None", "name")
            : this.findItem(payCodeList, settingSelected.vtoPayCode, "id"),
        requestSubtype: this.findItem(
          getRequestSubTypeList(settingSelected.actionType),
          settingSelected.requestSubtype,
          "value"
        ),
        segmentTag:
          settingSelected.segmentTagId === 0
            ? this.findItem(segmentTagsList, "None", "name")
            : this.findItem(
              segmentTagsList,
              settingSelected.segmentTagId,
              "id"
            ),
        template1: this.getTemplate(0),
        template10: this.getTemplate(9),
        template11: this.getTemplate(10),
        template12: this.getTemplate(11),
        template13: this.getTemplate(12),
        template14: this.getTemplate(13),
        template15: this.getTemplate(15),
        template16: this.getTemplate(16),
        template2: this.getTemplate(1),
        template3: this.getTemplate(2),
        template4: this.getTemplate(3),
        template5: this.getTemplate(4),
        template6: this.getTemplate(5),
        template7: this.getTemplate(6),
        template8: this.getTemplate(7),
        template9: this.getTemplate(8),
        timePeriodRatioOptions: timePeriodRatioOptions,
        vtoCoverageRequiredEdgeSelected:
          settingSelected.vtoCoverageRequiredEdge,
        vtoTypes: vtoTypes,
        workRule:
          settingSelected.workRuleId === 0
            ? this.findItem(workRuleList, "None", "name")
            : this.findItem(workRuleList, settingSelected.workRuleId, "value"),
        maxAllowedPartial: settingSelected.maxAllowedPartial,
        privateEmployeeSource: this.findItem(
          privateEmployeeSources,
          settingSelected.privateEmployeeSource,
          "value"
        ),
        isKeepEmployeeWorkRule: settingSelected.isKeepEmployeeWorkRule,
        isOverwriteRequestPeriodNumberOfMonthsInFuture: settingSelected.isOverwriteRequestPeriodNumberOfMonthsInFuture,
        overwriteRequestPeriodNumberOfMonthsInFuture: settingSelected.overwriteRequestPeriodNumberOfMonthsInFuture,
        isVtoOverlapChecked: settingSelected.isVtoOverlapChecked,
        vtoPaycodeCreationType: settingSelected.vtoPaycodeCreationType != null
          ? getVtoPaycodeCreationTypeOptions().find(x => x.value === settingSelected.vtoPaycodeCreationType)
          : null,
        workRules: {
          included: [
            ...workRuleList.filter(rule =>
              !settingSelected.workRuleExcludedIds?.includes(rule.value) &&
              rule.label !== "None"
            )
          ],
          excluded: [
            ...workRuleList.filter(rule => settingSelected.workRuleExcludedIds?.includes(rule.value))
          ],
        },
        warnings: settingSelected.warnings,
        isVtoPaycodeBreakRuleEnabled: settingSelected.isVtoPaycodeBreakRuleEnabled,
        vtoPaycodeBreakRule: breakRuleList.map(x => ({ value: x.id, label: x.label })).find(x => x.value === settingSelected.vtoPaycodeBreakRuleId),
        segmentTagsFilter: {
          included: [
            ...segmentTagsList.filter(x =>
              !settingSelected.segmentTagExcludedIds?.includes(x.id) &&
              x.label !== "None"
            )
          ],
          excluded: [
            ...segmentTagsList.filter(x =>
              settingSelected.segmentTagExcludedIds?.includes(x.id)
            )
          ],
        },
        torCreationType: this.findItem(getTorCreationTypeOptions(), settingSelected.torCreationType, "value"),
      };

      const updateState = {
        ...stateFromSelectedSetting,
        prevState: stateFromSelectedSetting,
      };

      this.setState(updateState, () => this.submitableForm());
    }
  };

  findItem = (list, id, key) => {
    let auxFind = list.find((item) => item[key] === id);
    return typeof auxFind === "undefined" ? "" : auxFind;
  };

  getTemplate = (template) => {
    const { settingSelected, genericNotificationList } = this.props;
    let auxTemplates = settingSelected.notificationTemplates;
    let auxValue = this.findItem(auxTemplates, template, "type");
    return this.findItem(genericNotificationList, auxValue.templateId, "value");
  };

  handleChangeTextfield = (target, value) => {
    if (target === "name") {
      this.setState(
        {
          [target]: value,
          errorName: false,
        },
        () => this.submitableForm()
      );
    } else {
      this.setState({ [target]: value }, () => this.submitableForm());
    }
  };

  /**
   * @param {boolean} checked
   */
  handleChangeEnablePartialShift = (checked) => {
    this.setState(
      {
        enablePartialShifts: checked,
        multiplePartial: false,
        isAllowPartialOfPartial: false,
        minimumPartialShiftDuration: 0,
        minimumPartialShiftBalanceDuration: 0,
        isPartialOnlyOnEdges: false,
        maxAllowedPartial: 0,
      },
      () => this.submitableForm()
    );
  };

  submitForm = () => {
    const {
      actionType,
      autoApproval,
      awardingRule,
      breRuleSet,
      createOpenShift,
      creationHyperFindQuery,
      dataview,
      dataviewColumns,
      description,
      enablePartialShifts,
      isAutoExpiryTimeOnPrivateOfferEnabled,
      autoExpiryTimeOnPrivateOffer,
      isTimeOffRequestCreationAutoApproval,
      isAllowToCoverApprovalWhenPtoIsRejected,
      enableShiftSwapEmployeePreferences,
      groupedShiftSwap,
      isAllowMultipleRequests,
      isAllowProposalWithOffer,
      isAllowSignUpPeriodWithOpenShift,
      isAllowSignUpPeriodWithShiftSwapShift,
      isAllowSignUpPeriodWithToCoverShift,
      isBlockOsOverlap,
      isPartialOnlyOnEdges,
      isSubmitable,
      managementHyperFindQuery,
      minimumPartialShiftBalanceDuration,
      minimumPartialShiftDuration,
      minimumShiftBalanceDuration,
      minutesToBlockOs,
      multiplePartial,
      isAllowPartialOfPartial,
      name,
      requestSubtype,
      payCode,
      segmentTag,
      template1,
      template10,
      template11,
      template12,
      template13,
      template14,
      template15,
      template16,
      template2,
      template3,
      template4,
      template5,
      template6,
      template7,
      template8,
      template9,
      timePeriodRatioOptions,
      vtoCoverageRequiredEdgeSelected,
      vtoTypes,
      workRule,
      maxAllowedPartial,
      privateEmployeeSource,
      isKeepEmployeeWorkRule,
      isOverwriteRequestPeriodNumberOfMonthsInFuture,
      overwriteRequestPeriodNumberOfMonthsInFuture,
      isVtoOverlapChecked,
      vtoPaycodeCreationType,
      workRules,
      isVtoPaycodeBreakRuleEnabled,
      vtoPaycodeBreakRule,
      segmentTagsFilter,
      torCreationType
    } = this.state;

    if (isSubmitable) {
      if (this.uniqueName()) {
        let newForm = {};

        newForm.name = name;
        newForm.description = description;
        newForm.creationHyperfindId = creationHyperFindQuery.value;
        newForm.managementHyperfindId = managementHyperFindQuery.value;
        newForm.autoApproval = autoApproval;
        newForm.actionType = actionType.value;
        newForm.isBlockOsOverlap = isBlockOsOverlap;

        newForm.notificationTemplates = [
          { type: 0, templateId: template1.value },
          { type: 1, templateId: template2.value },
          { type: 2, templateId: template3.value },
          { type: 3, templateId: template4.value },
          { type: 4, templateId: template5.value },
          { type: 5, templateId: template6.value },
          { type: 6, templateId: template7.value },
          { type: 7, templateId: template8.value },
          { type: 8, templateId: template9.value },
          { type: 9, templateId: template10.value },
          { type: 10, templateId: template11.value },
          { type: 11, templateId: template12.value },
          { type: 12, templateId: template13.value },
          { type: 13, templateId: template14.value },
          { type: 15, templateId: template15.value },
          { type: 16, templateId: template16.value },
        ];

        newForm.dataviewId = dataview.value;
        newForm.dataviewDisplayedCols = dataviewColumns.excluded.map(
          (col) => col.key
        );

        newForm.autoExpiryTimeOnPrivateOffer = isAutoExpiryTimeOnPrivateOfferEnabled ? autoExpiryTimeOnPrivateOffer : null;

        if (actionType.value === RequestTypes.toCover) {
          newForm.segmentTagId =
            segmentTag.name !== "None" ? segmentTag.id : null;
          newForm.breRuleSetId =
            breRuleSet.name !== "None" ? breRuleSet.id : null;
          newForm.workRuleId = workRule.name !== "None" ? workRule.value : 0;

          newForm.enablePartialShifts = enablePartialShifts;
          newForm.torCreationType = torCreationType.value;
          newForm.isAutoExpiryTimeOnPrivateOfferEnabled = isAutoExpiryTimeOnPrivateOfferEnabled;
          if (torCreationType.value == TorCreationType.Optional || torCreationType.value == TorCreationType.Required) {
            newForm.isTimeOffRequestCreationAutoApproval = isTimeOffRequestCreationAutoApproval;
            newForm.isAllowToCoverApprovalWhenPtoIsRejected = isAllowToCoverApprovalWhenPtoIsRejected;
          }
          newForm.minimumPartialShiftDuration = minimumPartialShiftDuration;
          newForm.minimumPartialShiftBalanceDuration =
            minimumPartialShiftBalanceDuration;
          newForm.multiplePartial = multiplePartial;
          newForm.isPartialOnlyOnEdges = isPartialOnlyOnEdges;
          newForm.isAllowPartialOfPartial = isAllowPartialOfPartial;
          newForm.maxAllowedPartial = maxAllowedPartial;
          newForm.privateEmployeeSource = privateEmployeeSource.value;
          newForm.workRuleExcludedIds = workRules.excluded.map(elem => elem.workRuleId);
          newForm.segmentTagExcludedIds = segmentTagsFilter.excluded.map(elem => elem.id.toString())
        }

        if (actionType.value === RequestTypes.shiftSwap) {
          newForm.segmentTagId =
            segmentTag.name !== "None" ? segmentTag.id : null;
          newForm.breRuleSetId =
            breRuleSet.name !== "None" ? breRuleSet.id : null;
          newForm.workRuleId = workRule.name !== "None" ? workRule.value : 0;

          newForm.isAllowProposalWithOffer = isAllowProposalWithOffer;
          newForm.groupedShiftSwap = groupedShiftSwap;
          newForm.isAllowMultipleRequests = isAllowMultipleRequests;
          newForm.isAutoExpiryTimeOnPrivateOfferEnabled = isAutoExpiryTimeOnPrivateOfferEnabled;
          newForm.enableShiftSwapEmployeePreferences =
            enableShiftSwapEmployeePreferences;

          newForm.enablePartialShifts = enablePartialShifts;
          newForm.minimumPartialShiftDuration = minimumPartialShiftDuration;
          newForm.minimumPartialShiftBalanceDuration =
            minimumPartialShiftBalanceDuration;
          newForm.multiplePartial = multiplePartial;
          newForm.isPartialOnlyOnEdges = isPartialOnlyOnEdges;
          newForm.isAllowPartialOfPartial = isAllowPartialOfPartial;
          newForm.maxAllowedPartial = maxAllowedPartial;
          newForm.isKeepEmployeeWorkRule = isKeepEmployeeWorkRule;
          newForm.privateEmployeeSource = privateEmployeeSource.value;
          newForm.overwriteRequestPeriodNumberOfMonthsInFuture = overwriteRequestPeriodNumberOfMonthsInFuture == null ? null : overwriteRequestPeriodNumberOfMonthsInFuture;
          newForm.isOverwriteRequestPeriodNumberOfMonthsInFuture = isOverwriteRequestPeriodNumberOfMonthsInFuture;
          newForm.workRuleExcludedIds = workRules.excluded.map(elem => elem.workRuleId);
          newForm.segmentTagExcludedIds = segmentTagsFilter.excluded.map(elem => elem.id.toString())
        }

        if (actionType.value === RequestTypes.openShift) {
          newForm.segmentTagId =
            segmentTag.name !== "None" ? segmentTag.id : null;
          newForm.breRuleSetId =
            breRuleSet.name !== "None" ? breRuleSet.id : null;

          newForm.requestSubtype = requestSubtype.value;

          newForm.enablePartialShifts = enablePartialShifts;
          newForm.minimumPartialShiftDuration = minimumPartialShiftDuration;
          newForm.minimumPartialShiftBalanceDuration =
            minimumPartialShiftBalanceDuration;
          newForm.minutesToBlockOs = minutesToBlockOs;
          newForm.isPartialOnlyOnEdges = isPartialOnlyOnEdges;
          newForm.maxAllowedPartial = maxAllowedPartial;

          if (requestSubtype.value === RequestSubtypes.signUp) {
            newForm.awardingRuleId = awardingRule.id;
          }
        }

        if (actionType.value === RequestTypes.voluntaryTimeOff) {
          newForm.createOpenShift = createOpenShift;
          newForm.breRuleSetId =
            breRuleSet.name !== "None" ? breRuleSet.id : null;

          newForm.requestSubtype = requestSubtype.value;
          if (requestSubtype.value === RequestSubtypes.signUp) {
            newForm.awardingRuleId = awardingRule.id;
          }

          newForm.VtoPayCode = payCode.name !== "None" ? payCode.id : 0;
          newForm.voluntaryTimeOffTypes = vtoTypes
            .filter((type) => type.checked)
            .map((type) => type.value);
          newForm.vtoCoverageRequiredEdge = vtoCoverageRequiredEdgeSelected;
          newForm.timePeriodRatioOptions = timePeriodRatioOptions
            .filter((option) => option.checked)
            .map((option) => option.id);
          newForm.isAllowSignUpPeriodWithToCoverShift =
            isAllowSignUpPeriodWithToCoverShift;
          newForm.isAllowSignUpPeriodWithShiftSwapShift =
            isAllowSignUpPeriodWithShiftSwapShift;
          newForm.isAllowSignUpPeriodWithOpenShift =
            isAllowSignUpPeriodWithOpenShift;
          newForm.isVtoOverlapChecked = isVtoOverlapChecked;
          newForm.vtoPaycodeCreationType = vtoPaycodeCreationType?.value;
          newForm.isVtoPaycodeBreakRuleEnabled = isVtoPaycodeBreakRuleEnabled;
          newForm.vtoPaycodeBreakRuleId = vtoPaycodeBreakRule?.value;
          newForm.minimumShiftBalanceDuration = minimumShiftBalanceDuration;

          // Partial shift settings for VTO (only applicable to TimePeriod type)
          newForm.enablePartialShifts = enablePartialShifts;
          newForm.minimumPartialShiftDuration = minimumPartialShiftDuration;
          newForm.isPartialOnlyOnEdges = isPartialOnlyOnEdges;
        }
        this.props.handleSubmitForm(newForm);
      } else {
        this.setState({ errorName: true });
      }
      this.setState({ errorSubmitForm: false });
    } else {
      this.setState({ errorSubmitForm: true });
    }
  };

  handleChange = (event, target) => {
    this.setState(
      {
        [target]: event,
        ...(target === "actionType"
          ? {
            requestSubtype: null,
            ...cloneDeep(RESET_ADMIN_SETTING_FORM_VALUES),
          }
          : {}),
        ...(target === "torCreationType"
          ? {
            isTimeOffRequestCreationAutoApproval: event.value !== TorCreationType.None,
            isShowTimeOffRequestWarning: event.value !== TorCreationType.None,
          }
          : {}),
      },
      () => this.submitableForm()
    );
  };

  updating = (currentID) => {
    if (
      this.props.action === "Edit" &&
      this.props.settingSelected.id === currentID
    ) {
      return false;
    }
    return true;
  };

  uniqueName = () => {
    const { settingList } = this.props;
    for (let i = 0; i < settingList.length; i++) {
      if (
        settingList[i].name === this.state.name &&
        this.updating(settingList[i].id)
      ) {
        return false;
      }
    }
    return true;
  };

  submitableForm = () => {
    const {
      actionType,
      autoApproval,
      awardingRule,
      breRuleSet,
      createOpenShift,
      creationHyperFindQuery,
      dataview,
      dataviewColumns,
      description,
      enablePartialShifts,
      isAutoExpiryTimeOnPrivateOfferEnabled,
      autoExpiryTimeOnPrivateOffer,
      isTimeOffRequestCreationAutoApproval,
      isAllowToCoverApprovalWhenPtoIsRejected,
      enableShiftSwapEmployeePreferences,
      errorName,
      groupedShiftSwap,
      isAllowProposalWithOffer,
      isAllowSignUpPeriodWithOpenShift,
      isAllowSignUpPeriodWithShiftSwapShift,
      isAllowSignUpPeriodWithToCoverShift,
      isBlockOsOverlap,
      isPartialOnlyOnEdges,
      managementHyperFindQuery,
      minimumPartialShiftBalanceDuration,
      minimumPartialShiftDuration,
      minimumShiftBalanceDuration,
      minWorkedHours,
      minWorkedPeriod,
      minutesToBlockOs,
      multiplePartial,
      isAllowPartialOfPartial,
      name,
      payCode,
      prevState,
      requestSubtype,
      segmentTag,
      template1,
      template10,
      template11,
      template12,
      template13,
      template14,
      template15,
      template16,
      template2,
      template3,
      template4,
      template5,
      template6,
      template7,
      template8,
      template9,
      timePeriodRatioOptions,
      vtoCoverageRequiredEdgeSelected,
      vtoCoverageRequiredEdgesOptions,
      vtoTypes,
      workRule,
      maxAllowedPartial,
      privateEmployeeSource,
      isKeepEmployeeWorkRule,
      isOverwriteRequestPeriodNumberOfMonthsInFuture,
      overwriteRequestPeriodNumberOfMonthsInFuture,
      isVtoOverlapChecked,
      vtoPaycodeCreationType,
      workRules,
      isVtoPaycodeBreakRuleEnabled,
      vtoPaycodeBreakRule,
      segmentTagsFilter,
      torCreationType
    } = this.state;

    let hasValidationErrors = true;

    let isFormDirty = name !== prevState.name ||
      description !== prevState.description ||
      creationHyperFindQuery !== prevState.creationHyperFindQuery ||
      managementHyperFindQuery !== prevState.managementHyperFindQuery ||
      dataview !== prevState.dataview ||
      autoApproval !== prevState.autoApproval ||
      JSON.stringify(requestSubtype) !== JSON.stringify(prevState.requestSubtype) ||
      enablePartialShifts !== prevState.enablePartialShifts ||
      isAutoExpiryTimeOnPrivateOfferEnabled !==
      prevState.isAutoExpiryTimeOnPrivateOfferEnabled ||
      autoExpiryTimeOnPrivateOffer !==
      prevState.autoExpiryTimeOnPrivateOffer ||
      isTimeOffRequestCreationAutoApproval !==
      prevState.isTimeOffRequestCreationAutoApproval ||
      isAllowToCoverApprovalWhenPtoIsRejected !==
      prevState.isAllowToCoverApprovalWhenPtoIsRejected ||
      multiplePartial !== prevState.multiplePartial ||
      isAllowPartialOfPartial !== prevState.isAllowPartialOfPartial ||
      minimumPartialShiftDuration !== prevState.minimumPartialShiftDuration ||
      minimumPartialShiftBalanceDuration !== prevState.minimumPartialShiftBalanceDuration ||
      minimumShiftBalanceDuration !== prevState.minimumShiftBalanceDuration ||
      isBlockOsOverlap !== prevState.isBlockOsOverlap ||
      minutesToBlockOs !== prevState.minutesToBlockOs ||
      isPartialOnlyOnEdges !== prevState.isPartialOnlyOnEdges ||
      minWorkedHours !== prevState.minWorkedHours ||
      minWorkedPeriod !== prevState.minWorkedPeriod ||
      groupedShiftSwap !== prevState.groupedShiftSwap ||
      payCode !== prevState.payCode ||
      awardingRule !== prevState.awardingRule ||
      createOpenShift !== prevState.createOpenShift ||
      template1 !== prevState.template1 ||
      template2 !== prevState.template2 ||
      template3 !== prevState.template3 ||
      template4 !== prevState.template4 ||
      template5 !== prevState.template5 ||
      template6 !== prevState.template6 ||
      template7 !== prevState.template7 ||
      template8 !== prevState.template8 ||
      template9 !== prevState.template9 ||
      template10 !== prevState.template10 ||
      template11 !== prevState.template11 ||
      template12 !== prevState.template12 ||
      template13 !== prevState.template13 ||
      template14 !== prevState.template14 ||
      template15 !== prevState.template15 ||
      template16 !== prevState.template16 ||
      breRuleSet !== prevState.breRuleSet ||
      workRule !== prevState.workRule ||
      segmentTag !== prevState.segmentTag ||
      enableShiftSwapEmployeePreferences !== prevState.enableShiftSwapEmployeePreferences ||
      isAllowSignUpPeriodWithToCoverShift !== prevState.isAllowSignUpPeriodWithToCoverShift ||
      isAllowSignUpPeriodWithShiftSwapShift !== prevState.isAllowSignUpPeriodWithShiftSwapShift ||
      isAllowSignUpPeriodWithOpenShift !== prevState.isAllowSignUpPeriodWithOpenShift ||
      isAllowProposalWithOffer !== prevState.isAllowProposalWithOffer ||
      JSON.stringify(dataviewColumns) !== JSON.stringify(prevState.dataviewColumns) ||
      JSON.stringify(timePeriodRatioOptions) !== JSON.stringify(prevState.timePeriodRatioOptions) ||
      JSON.stringify(vtoTypes) !== JSON.stringify(prevState.vtoTypes) ||
      vtoCoverageRequiredEdgeSelected !== prevState.vtoCoverageRequiredEdgeSelected ||
      this.props.action === 'Duplicate' ||
      maxAllowedPartial !== prevState.maxAllowedPartial ||
      privateEmployeeSource.value !== prevState.privateEmployeeSource.value ||
      isKeepEmployeeWorkRule !== prevState.isKeepEmployeeWorkRule ||
      isOverwriteRequestPeriodNumberOfMonthsInFuture !== prevState.isOverwriteRequestPeriodNumberOfMonthsInFuture ||
      overwriteRequestPeriodNumberOfMonthsInFuture !== prevState.overwriteRequestPeriodNumberOfMonthsInFuture ||
      isVtoOverlapChecked !== prevState.isVtoOverlapChecked ||
      JSON.stringify(vtoPaycodeCreationType) !== JSON.stringify(prevState.vtoPaycodeCreationType) ||
      JSON.stringify(workRules) !== JSON.stringify(prevState.workRules) ||
      isVtoPaycodeBreakRuleEnabled !== prevState.isVtoPaycodeBreakRuleEnabled ||
      vtoPaycodeBreakRule !== prevState.vtoPaycodeBreakRule ||
      JSON.stringify(segmentTagsFilter) !== JSON.stringify(prevState.segmentTagsFilter) ||
      torCreationType.value !== prevState.torCreationType.value;

    const isSignUp = requestSubtype?.value === RequestSubtypes.signUp;
    switch (actionType.value) {
      case RequestTypes.toCover:
        hasValidationErrors = errorName || creationHyperFindQuery === '' || managementHyperFindQuery === '' || name.trim() === ''
          || (torCreationType.value === TorCreationType.None && isTimeOffRequestCreationAutoApproval)
          || (torCreationType.value === TorCreationType.None && isAllowToCoverApprovalWhenPtoIsRejected)
          || template1 === '' || template2 === ''
          || template3 === '' || template4 === '' || template5 === '' || template6 === '' || template7 === ''
          || template8 === '' || template9 === '' || template10 === '' || template13 === '' || template16 === ''
          || breRuleSet === '' || workRule === '' || (enablePartialShifts && maxAllowedPartial === null) ||
          privateEmployeeSource === null;
        break
      case RequestTypes.shiftSwap:
        hasValidationErrors = errorName || creationHyperFindQuery === '' || managementHyperFindQuery === '' || name.trim() === '' || template1 === '' || template2 === ''
          || template3 === '' || template4 === '' || template5 === '' || template6 === '' || template7 === ''
          || template8 === '' || template9 === '' || template10 === '' || template11 === '' || template12 === ''
          || template13 === '' || template14 === '' || template15 === '' || template16 === ''
          || breRuleSet === '' || workRule === ''
          || (breRuleSet.isMultipleShiftOnSameDayRuleEnabled && groupedShiftSwap) || (enablePartialShifts && maxAllowedPartial === null) ||
          (isKeepEmployeeWorkRule && groupedShiftSwap) ||
          privateEmployeeSource === null ||
          (isOverwriteRequestPeriodNumberOfMonthsInFuture && overwriteRequestPeriodNumberOfMonthsInFuture === null);
        break
      case RequestTypes.openShift:
        hasValidationErrors = errorName || creationHyperFindQuery === '' || managementHyperFindQuery === '' || name.trim() === '' || template1 === '' || template2 === ''
          || template4 === '' || template6 === '' || template7 === ''
          || template8 === '' || template9 === '' || template10 === '' || template13 === ''
          || breRuleSet === '' || (isSignUp && awardingRule === '');
        break
      case RequestTypes.voluntaryTimeOff:
        var noVtoTypeSelected = vtoTypes.every(type => !type.checked);
        var isTimePeriodSelected = vtoTypes.some(type => type.value === VoluntaryTimeOffType.TimePeriod && type.checked);

        hasValidationErrors = errorName || creationHyperFindQuery === '' || managementHyperFindQuery === '' || name.trim() === '' || template1 === '' || template2 === ''
          || template8 === '' || template9 === '' || template10 === ''
          || template13 === '' || breRuleSet === ''
          || noVtoTypeSelected
          || (isTimePeriodSelected && timePeriodRatioOptions.every(option => !option.checked))
          || (isTimePeriodSelected && !vtoCoverageRequiredEdgesOptions.some(option => option.value === vtoCoverageRequiredEdgeSelected))
          || (isSignUp && awardingRule === '')
          || (!vtoTypes.find((type) => type.checked && type.value === VoluntaryTimeOffType.TimePeriod) && isVtoOverlapChecked === true)
          || (!vtoTypes.find((type) => type.checked && type.value === VoluntaryTimeOffType.TimePeriod) && vtoPaycodeCreationType !== null)
          || (vtoTypes.find((type) => type.checked && type.value === VoluntaryTimeOffType.TimePeriod) && vtoPaycodeCreationType === null)
          || (!vtoTypes.find((type) => type.checked && type.value === VoluntaryTimeOffType.TimePeriod) && enablePartialShifts)
          || (enablePartialShifts && vtoPaycodeCreationType?.value !== VtoPaycodeCreationType.Overlap)
          || isVtoPaycodeBreakRuleEnabled && vtoPaycodeBreakRule === null;

        break
      default:
        hasValidationErrors = false;
    }

    this.setState({
      isSubmitable: !hasValidationErrors && isFormDirty,
    })
  }

  generateInputs = (labelTypo, placeholder, value, list, target, disabled = false, note, helpIconText = null) => {
    //TODO OT 10-10: Replace with Form.service.generateInputs
    return <ReactSelect
      labelText={labelTypo}
      placeholder={placeholder}
      value={value}
      options={list}
      onChange={((target, value) => this.handleChange(value, target))}
      target={target}
      isDisabled={disabled}
      note={note}
      helpIconText={helpIconText}
    />
  }

  /**
   * @param {(checked: boolean) => void} ToggleFct
   */
  generateToggle = (
    ToggleFct,
    value,
    labelOn,
    labelOff,
    note,
    hidden,
    key,
    disabled = false,
    tooltipOnDisabled = null,
  ) => {
    //TODO kat 02-14: Replace with Form.service.generateToggle
    return (
      <ReactToggle
        ToggleFct={(checked) => ToggleFct(checked)}
        labelOn={labelOn}
        labelOff={labelOff}
        note={note}
        toggleValue={value}
        hidden={hidden}
        disabled={disabled}
        tooltipOnDisabled={tooltipOnDisabled}
        key={`${key}_${value}`}
      />
    );
  };

  getListIndex = (list, value) => {
    for (let i = 0; i < list.length; i++) {
      if (list[i].value === value) return i;
    }
    return "";
  };

  handleDataviewSelect = (target, value) => {
    this.setState(
      {
        [target]: value,
        dataviewColumns: {
          included:
            value.label !== "None"
              ? value.fields.map((field) => {
                return {
                  ...field,
                  value: field.key,
                };
              })
              : [],
          excluded: [],
        },
      },
      () => this.submitableForm()
    );
  };

  handleCheckboxSelect = (target, value) => {
    const parsedValue = parseInt(value);
    const isTimePeriodVto = target === 'vtoTypes' && parsedValue === 2;
    const currentItem = this.state[target].find(type => type.value === parsedValue);
    const isUnchecking = currentItem && currentItem.checked;

    const newState = {
      [target]: this.state[target].map((type) => {
        if (type.value === parsedValue) {
          return {
            ...type,
            checked: !type.checked,
          };
        }
        return type;
      }),
    };

    // Reset isVtoOverlapChecked and partial settings when unchecking Time Period VTO type
    if (isTimePeriodVto && isUnchecking) {
      newState.isVtoOverlapChecked = false;
      newState.enablePartialShifts = false;
      newState.minimumPartialShiftDuration = 0;
      newState.minimumShiftBalanceDuration = 0;
      newState.isPartialOnlyOnEdges = false;
    }

    this.setState(newState, () => this.submitableForm());
  };

  hideTimeOffRequestWarning() {
    this.setState({ isShowTimeOffRequestWarning: false });
  }

  /** @param {boolean} checked Updated value when triggered `onChange` */
  handleAutoExpiryOnPrivateOfferChange = (checked) => {
    this.setState({ isAutoExpiryTimeOnPrivateOfferEnabled: checked }, () => this.submitableForm());
  };

  /** @param {float} checked Updated value when triggered `onChange` */
  handleAutoExpiryTimeOnPrivateOfferChange = (value) => {
    this.setState({ autoExpiryTimeOnPrivateOffer: value }, () => this.submitableForm())
  }

  /** @param {boolean} checked Updated value when triggered `onChange` */
  handleIsKeepEmployeeWorkRuleCreationChange = (checked) => {
    this.setState({ isKeepEmployeeWorkRule: checked }, () => this.submitableForm());
  }

  /** @param {number} minutesToBlockOs */
  handleMinutesToBlockOsChange = (minutesToBlockOs) => {
    this.setState({ minutesToBlockOs }, () => this.submitableForm());
  };

  handleOverwriteRequestPeriodToggle = (checked) => {
    this.setState({ isOverwriteRequestPeriodNumberOfMonthsInFuture: checked }, () => {
      if (!checked) {
        this.setState({ overwriteRequestPeriodNumberOfMonthsInFuture: null });
      }
      this.submitableForm();
    });
  };

  handleOverwritePeriodDropdownChange = (value) => {
    this.setState({ overwriteRequestPeriodNumberOfMonthsInFuture: value.value }, () => this.submitableForm());
  };

  handleChangeDualBox = (target, updatedIncluded, updatedExcluded) => {
    this.setState(prevState => ({
      ...prevState,
      [target]: {
        ...prevState[target],
        included: updatedIncluded,
        excluded: updatedExcluded,
      }
    }), () => this.submitableForm());
  };

  moveAll = (target, isMovingToIncluded) => {
    this.setState(prevState => {
      const { included, excluded } = prevState[target];
      if (isMovingToIncluded) {
        return {
          [target]: {
            included: [...included, ...excluded],
            excluded: [],
          }
        };
      } else {
        return {
          [target]: {
            included: [],
            excluded: [...excluded, ...included],
          }
        };
      }
    }, () => this.submitableForm());
  };


  render() {
    const {
      action,
      actionTypeList,
      awardingRulesList,
      breRuleSetList,
      cancel,
      classes,
      dataviewList,
      genericNotificationList,
      hyperFindList,
      payCodeList,
      segmentTagsList,
      t,
      workRuleList,
      privateEmployeeSources,
      breakRuleList
    } = this.props;

    const {
      actionType,
      autoApproval,
      awardingRule,
      breRuleSet,
      createOpenShift,
      creationHyperFindQuery,
      dataview,
      dataviewColumns,
      description,
      enablePartialShifts,
      isAutoExpiryTimeOnPrivateOfferEnabled,
      autoExpiryTimeOnPrivateOffer,
      isTimeOffRequestCreationAutoApproval,
      isAllowToCoverApprovalWhenPtoIsRejected,
      enableShiftSwapEmployeePreferences,
      errorName,
      groupedShiftSwap,
      isAllowMultipleRequests,
      isAllowProposalWithOffer,
      isAllowSignUpPeriodWithOpenShift,
      isAllowSignUpPeriodWithShiftSwapShift,
      isAllowSignUpPeriodWithToCoverShift,
      isBlockOsOverlap,
      isUsedAdminSetting,
      isSubmitable,
      isShowTimeOffRequestWarning,
      managementHyperFindQuery,
      minutesToBlockOs,
      name,
      payCode,
      requestSubtype,
      segmentTag,
      template1,
      template10,
      template11,
      template12,
      template13,
      template14,
      template15,
      template16,
      template2,
      template3,
      template4,
      template5,
      template6,
      template7,
      template8,
      template9,
      vtoTypes,
      workRule,
      maxAllowedPartial,
      privateEmployeeSource,
      isKeepEmployeeWorkRule,
      isOverwriteRequestPeriodNumberOfMonthsInFuture,
      overwriteRequestPeriodNumberOfMonthsInFuture,
      workRules,
      warnings,
      isVtoPaycodeBreakRuleEnabled,
      vtoPaycodeBreakRule,
      segmentTagsFilter,
      torCreationType
    } = this.state;

    const isRequestSubtypeSignUp =
      requestSubtype?.value === RequestSubtypes.signUp;
    const isOpenShift = actionType.value === RequestTypes.openShift;
    const isShiftSwap = actionType.value === RequestTypes.shiftSwap;
    const isToCover = actionType.value === RequestTypes.toCover;
    const isVoluntaryTimeOff =
      actionType.value === RequestTypes.voluntaryTimeOff;

    const isEdit = action === "Edit";

    /** @type {boolean} */
    const isDisabledEdit = isEdit && isUsedAdminSetting;
    const isDisabledEditHyperfindCreate = isEdit && isUsedAdminSetting && !warnings?.includes("IsFailingCreationHyperfindExecution");
    const isDisabledEditHyperfindManage = isEdit && isUsedAdminSetting && !warnings?.includes("IsFailingManagementHyperfindExecution");

    if (document.getElementById("sidebar")) {
      document
        .getElementById("sidebar")
        .parentElement.classList.remove(classes.NOOVERFLOW);
    }

    const containerClass = [classes.formContainer];
    if (action === AdminSidePanelActionNames.View) {
      containerClass.push(classes.formContainerReadOnly);
    }

    const informationSection = (index) => {
      return (
        <Card className={classes.cards}>
          <CardHeader
            className={classes.cardHeader}
            color="textSecondary"
            gutterBottom
            avatar={<Avatar className={classes.avatar}>{index}</Avatar>}
            title={t("form.information")}
          />
          <CardContent>
            <DebouncedTextField
              classes={classes}
              label={t("settings.name")}
              error={name.trim() === "" || errorName}
              value={name}
              valueString={"name"}
              changeHandler={this.handleChangeTextfield}
              inputLength={50}
              placeholder={t("form.namePlaceholder")}
            />
            <p>
              <small className={classes.maxLength}>{t("form.descName")}</small>
            </p>
            <DebouncedTextField
              classes={classes}
              label={t("settings.description_long")}
              value={description}
              valueString={"description"}
              multiline={true}
              rows={4}
              changeHandler={this.handleChangeTextfield}
              inputLength={50}
              placeholder={t("form.descriptionPlaceholder")}
            />
            <div className={classes.requestSubtypeInput}>
              {this.generateInputs(
                t("settings.actionType"),
                t("form.requestTypeSelect"),
                actionType,
                actionTypeList,
                "actionType",
                isDisabledEdit
              )}
            </div>
            {(isOpenShift || isVoluntaryTimeOff) && (
              <ReactSelect
                isDisabled={isDisabledEdit}
                labelText={
                  isOpenShift ? t("form.openShiftType") : t("form.vtoType")
                }
                onChange={(_, /** @type {ListItem} */ selectedValue) => {
                  this.setState(
                    {
                      requestSubtype: selectedValue,
                      breRuleSet: this.findItem(breRuleSetList, "None", "name"),
                      ...cloneDeep(RESET_ADMIN_SETTING_FORM_VALUES),
                    },
                    () => this.submitableForm()
                  );
                }}
                options={getRequestSubTypeList(
                  isOpenShift
                    ? RequestTypes.openShift
                    : RequestTypes.voluntaryTimeOff
                )}
                placeholder={
                  isOpenShift
                    ? t("form.openShiftTypeSelect")
                    : t("form.vtoTypeSelect")
                }
                target={"requestSubtype"}
                value={requestSubtype}
              />
            )}
          </CardContent>
        </Card>
      );
    };

    const displayAccessSection = (index) => {
      const creationHyperfindWarningMessage = warnings?.includes(ConfigurationSetWarningCodes.IsFailingCreationHyperfindExecution) ? t('admin.warnings.IsFailingCreationHyperfindExecution') : null;
      const managementHyperfindWarningMessage = warnings?.includes(ConfigurationSetWarningCodes.IsFailingManagementHyperfindExecution) ? t('admin.warnings.IsFailingManagementHyperfindExecution') : null;
      return (
        <Card className={classes.cards}>
          <CardHeader
            className={classes.cardHeader}
            color="textSecondary"
            gutterBottom
            avatar={<Avatar className={classes.avatar}>{index}</Avatar>}
            title={t("form.displayAccess")}
          />
          <CardContent>
            <div className={classes.requestSubtypeInput}>
              <div style={{ display: 'flex' }}>
                <div style={{ width: '-webkit-fill-available' }}>
                  {this.generateInputs(
                    t("settings.creationHyperfind"),
                    t("form.employeeSelection"),
                    creationHyperFindQuery,
                    hyperFindList,
                    "creationHyperFindQuery",
                    isDisabledEditHyperfindCreate,
                    "*" + t("form.createHyperfindDisclamer"),
                  )}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', height: '70px' }}>
                  {creationHyperfindWarningMessage ? <WarningIconWithTooltip tooltipWarnings={[creationHyperfindWarningMessage]} /> : null}
                </div>
              </div>
              <div style={{ display: 'flex' }}>
                <div style={{ width: '-webkit-fill-available' }}>
                  {this.generateInputs(
                    t("settings.managementHyperfind"),
                    t("form.employeeSelection"),
                    managementHyperFindQuery,
                    hyperFindList,
                    "managementHyperFindQuery",
                    isDisabledEditHyperfindManage,
                    "*" + t("form.manageHyperfindDisclamer")
                  )}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', height: '70px' }}>
                  {managementHyperfindWarningMessage ? <WarningIconWithTooltip tooltipWarnings={[managementHyperfindWarningMessage]} /> : null}
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      );
    };

    const dataviewSection = (index) => {
      return (
        <Card className={classes.cards}>
          <CardHeader
            className={classes.cardHeader}
            color="textSecondary"
            gutterBottom
            avatar={<Avatar className={classes.avatar}>{index}</Avatar>}
            title={t("form.dataviewStepHeader")}
          />
          <CardContent>
            <div className={classes.requestSubtypeInput}>
              <ReactSelect
                labelText={t("settings.dataview")}
                placeholder={t("form.dataviewSelect")}
                value={dataview}
                options={dataviewList}
                onChange={this.handleDataviewSelect}
                target={"dataview"}
                isDisabled={false}
              />
              {dataview.label !== "None" ? (
                <DualListBox
                  data={dataviewColumns.excluded}
                  subHeader={"Dataview columns"}
                  rightBoxText={"Visible"}
                  leftBoxText={"Hidden"}
                  moveAllToRightText={"Show all"}
                  moveAllToLeftText={"Hide all"}
                  target={"dataviewColumns"}
                  dataSelected={dataviewColumns.included}
                  handleChangeDualBox={handleChangeDualBox(this)}
                  moveAll={moveAll(this)}
                  handleUpdates={this.submitableForm}
                />
              ) : null}
            </div>
          </CardContent>
        </Card>
      );
    };

    const schedulingSection = (index) => {
      return (
        <Card className={classes.cards}>
          <CardHeader
            className={classes.cardHeader}
            color="textSecondary"
            gutterBottom
            avatar={<Avatar className={classes.avatar}>{index}</Avatar>}
            title={t("form.scheduling")}
          />
          <CardContent>
            <div className={classes.requestSubtypeInput}>
              {this.generateInputs(
                t("settings.payCode"),
                t("form.payCodeSelect"),
                payCode,
                payCodeList,
                "payCode",
                false
              )}
              {this.generateToggle(
                () =>
                  this.setState({ createOpenShift: !createOpenShift }, () =>
                    this.submitableForm()
                  ),
                createOpenShift,
                t("form.createOpenShiftEnabled"),
                t("form.createOpenShiftDisabled"),
                "*" + t("form.createOpenShiftDisclaimer"),
                false,
                "createOpenShift",
                false
              )}
              {this.generateToggle(
                () => {
                  let stateToAdd = {};
                  if (isVtoPaycodeBreakRuleEnabled) stateToAdd = { vtoPaycodeBreakRule: null }
                  this.setState({ isVtoPaycodeBreakRuleEnabled: !isVtoPaycodeBreakRuleEnabled, ...stateToAdd }, () => {
                    this.submitableForm()
                  }
                  )
                },
                isVtoPaycodeBreakRuleEnabled,
                t("form.schedulingSection.breakRule.breakRulesEnabled"),
                t("form.schedulingSection.breakRule.breakRulesEnabled"),
                "",
                false,
                "isBreakRuleEnabled",
                false
              )}
              {isVtoPaycodeBreakRuleEnabled && this.generateInputs(
                t("form.schedulingSection.breakRule.breakRuleTitle"),
                t("form.schedulingSection.breakRule.breakRuleSelected"),
                vtoPaycodeBreakRule,
                breakRuleList.map(x => ({ value: x.id, label: x.label })),
                "vtoPaycodeBreakRule",
                false,
                null,
                t("form.schedulingSection.breakRule.breakRuleTooltip")
              )}
            </div>
          </CardContent>
        </Card>
      );
    };

    const rulesSection = (index) => {
      const isShowPartialShiftSection =
        isToCover || isShiftSwap || (isOpenShift && !isRequestSubtypeSignUp);

      return (
        <Card className={classes.cards}>
          <CardHeader
            className={classes.cardHeader}
            color="textSecondary"
            gutterBottom
            avatar={<Avatar className={classes.avatar}>{index}</Avatar>}
            title={t("form.shiftRules")}
          />
          <CardContent>
            {!isOpenShift &&
              !isVoluntaryTimeOff &&
              this.generateInputs(
                t("form.addWorkRule"),
                t("form.selectWorkRule"),
                workRule,
                workRuleList,
                "workRule",
                false,
                "*" + t("form.workRuleDisclamer")
              )}
            {!isVoluntaryTimeOff &&
              this.generateInputs(
                t("form.addSegmentTag"),
                t("form.selectSegmentTag"),
                segmentTag,
                segmentTagsList,
                "segmentTag",
                false,
                "*" + t("form.segmentTagDisclamer")
              )}

            <div
              className={classes.containerLabelsFullWidth}
              hidden={!isShiftSwap}
            >
              <Typography className={classes.subHeader} color="textSecondary" >{t('form.isKeepEmployeeWorkRule')}</Typography>
              {
                this.generateToggle(
                  (checked) => this.handleIsKeepEmployeeWorkRuleCreationChange(checked),
                  isKeepEmployeeWorkRule,
                  t('form.enabled'),
                  t('form.disabled'),
                  '*' + t('form.isKeepEmployeeWorkRuleDisclaimer'),
                  false,
                  "isKeepEmployeeWorkRule",
                  isAllowMultipleRequests && groupedShiftSwap,
                  getIsKeepEmployeeWorkRuleTooltipOnDisabled(isAllowMultipleRequests && groupedShiftSwap)
                )
              }
            </div>
            {isShowPartialShiftSection && renderPartialShiftSection()}

            <div
              className={classes.containerLabelsFullWidth}
              hidden={!isShiftSwap}
            >
              <RequestPeriodOverrideDropdown
                toggleLabel={t("form.proposals.changeDefaultValueDescription")}
                toggleValue={isOverwriteRequestPeriodNumberOfMonthsInFuture}
                onToggleChange={this.handleOverwriteRequestPeriodToggle}
                dropdownLabel={t("form.calendar.month")}
                dropdownValue={overwriteRequestPeriodNumberOfMonthsInFuture}
                onDropdownChange={this.handleOverwritePeriodDropdownChange}
              />
            </div>
            <div
              className={classes.containerLabelsFullWidth}
              hidden={!isToCover}
            >
              <Typography className={classes.subHeader} color="textSecondary">
                {t("form.createTOR")}
              </Typography>
              {this.generateInputs(
                t("form.createTOR"),
                t("form.selectTorCreationType"),
                torCreationType,
                getTorCreationTypeOptions(),
                "torCreationType",
                isUsedAdminSetting,
                "*" + t("form.createTORDisclaimer")
              )}
              <div
                className={classes.containerLabelsFullWidth}
                hidden={torCreationType.value === TorCreationType.None}
              >
                <Typography className={classes.subHeader} color="textSecondary">
                  <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                    {t("form.isTimeOffRequestCreationAutoApproval.label")}
                    {!isTimeOffRequestCreationAutoApproval ? <WarningIconWithTooltip tooltipWarnings={[t("form.isTimeOffRequestCreationAutoApproval.tooltip")]} placement={"topEnd"} maxWidth={400} /> : null}
                  </div>
                </Typography>
                <ReactToggle
                  ToggleFct={(checked) =>
                    this.setState(
                      {
                        isTimeOffRequestCreationAutoApproval:
                          !isTimeOffRequestCreationAutoApproval,
                        isShowTimeOffRequestWarning: !isTimeOffRequestCreationAutoApproval,
                      },
                      () => this.submitableForm()
                    )
                  }
                  labelOn={t("form.enabled")}
                  labelOff={t("form.disabled")}
                  note={"*" + t("form.isTimeOffRequestCreationAutoApproval.disclaimer")}
                  toggleValue={isTimeOffRequestCreationAutoApproval}
                  hidden={false}
                  disabled={isUsedAdminSetting}
                  tooltipOnDisabled={null}
                  key={`isTimeOffRequestCreationAutoApproval_${isTimeOffRequestCreationAutoApproval}`}
                />

                <Typography className={classes.subHeader} color="textSecondary">
                  <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                    {t("form.isAllowToCoverApprovalWhenPtoIsRejected.label")}
                    <Tooltip
                      title={
                        <>
                          {t("form.isAllowToCoverApprovalWhenPtoIsRejected.tooltip")}
                        </>
                      }
                      arrow
                    >
                      <HelpIcon
                        fontSize="small"
                      />
                    </Tooltip>
                  </div>
                </Typography>
                <ReactToggle
                  ToggleFct={(checked) =>
                    this.setState(
                      {
                        isAllowToCoverApprovalWhenPtoIsRejected:
                          !isAllowToCoverApprovalWhenPtoIsRejected,
                      },
                      () => this.submitableForm()
                    )
                  }
                  labelOn={t("form.enabled")}
                  labelOff={t("form.disabled")}
                  toggleValue={isAllowToCoverApprovalWhenPtoIsRejected}
                  hidden={false}
                  disabled={isUsedAdminSetting}
                  tooltipOnDisabled={null}
                  key={`isAllowToCoverApprovalWhenPTOIsRejected_${isAllowToCoverApprovalWhenPtoIsRejected}`}
                />

              </div>
            </div>
            {(isToCover || isShiftSwap) && (
              <>
                {t('form.workRuleFilter')}
                <hr />
                <Dualbox
                  data={workRules.excluded}
                  subHeader={t('form.chooseWorkRulesForExceptions')}
                  subHeaderStyle={{ fontSize: '12px' }}
                  target={'workRules'}
                  rightBoxText={t('form.excluded')}
                  leftBoxText={t('form.included')}
                  moveAllToRightText={t('form.selectAll')}
                  moveAllToLeftText={t('form.deselectAll')}
                  dataSelected={workRules.included}
                  handleChangeDualBox={handleChangeDualBox(this)}
                  moveAll={moveAll(this)}
                  handleUpdates={this.submitableForm} />
              </>)
            }
            {(isToCover || isShiftSwap) && (
              <>
                {t('form.segmentTagFilter')}
                <hr />
                <Dualbox
                  data={segmentTagsFilter.excluded}
                  subHeader={t('form.chooseSegmentTagsForExceptions')}
                  subHeaderStyle={{ fontSize: '12px' }}
                  target={'segmentTagsFilter'}
                  rightBoxText={t('form.excluded')}
                  leftBoxText={t('form.included')}
                  moveAllToRightText={t('form.selectAll')}
                  moveAllToLeftText={t('form.deselectAll')}
                  dataSelected={segmentTagsFilter.included}
                  handleChangeDualBox={handleChangeDualBox(this)}
                  moveAll={moveAll(this)}
                  handleUpdates={this.submitableForm} />
              </>)
            }
            <div
              className={classes.containerLabelsFullWidth}
              style={{ marginBottom: "-10px", paddingBottom: "56px" }}
              hidden={!isOpenShift}
            >
              <Typography
                className={classes.subHeader}
                style={{ marginBottom: "-8px" }}
                color="textSecondary"
              >
                {t("form.tcAndOSRequests")}
              </Typography>
              <div className={classes.containerOverlappingTc}>
                <div className={classes.isBlockOsToggleContainer}>
                  {this.generateToggle(
                    () =>
                      this.setState(
                        { isBlockOsOverlap: !isBlockOsOverlap },
                        () => this.submitableForm()
                      ),
                    isBlockOsOverlap,
                    t("form.blockOsIfOverlaps"),
                    t("form.blockOsIfOverlaps"),
                    `*${t("form.noOverlapIfBlockOsIsOff")}`,
                    false,
                    "isBlockOsOverlap",
                    !isOpenShift
                  )}
                </div>
                <DebouncedNumericPicker
                  min={0}
                  disabled={!isOpenShift || !isBlockOsOverlap}
                  value={minutesToBlockOs}
                  onChange={this.handleMinutesToBlockOsChange}
                  classes={{
                    container: classes.numberPickers,
                  }}
                  style={{
                    ...HoursMinutesPickerStyles,
                    input: {
                      ...HoursMinutesPickerStyles.input,
                      maxWidth: 64,
                    },
                  }}
                />
                <small className={classes.formControlLabel}>
                  {t("form.minutesWithApprovedTc")}
                </small>
              </div>
            </div>
          </CardContent>
        </Card>
      );
    };

    const requestsRulesSection = (index, requestType) => {
      let cardContent;
      const isGroupedShiftSwapDisabled =
        isDisabledEdit ||
        isAllowProposalWithOffer ||
        breRuleSet.isMultipleShiftOnSameDayRuleEnabled ||
        isKeepEmployeeWorkRule;

      if (
        requestType === RequestTypes.shiftSwap ||
        requestType === RequestTypes.toCover
      ) {
        cardContent = (
          <CardContent>
            Private offer options
            <hr />
            {requestType === RequestTypes.shiftSwap && (
              <>
                <div className={classes.containerLabelsFullWidth}>
                  <Typography className={classes.subHeader} color="textSecondary">
                    {t("form.isAllowProposalWithOffer")}
                  </Typography>
                </div>
                {this.generateToggle(
                  () => {
                    let otherProps = {};
                    if (!isAllowProposalWithOffer) { //toggle being set to true, then force enableShiftSwapEmployeePreferences and groupedShiftSwap values
                      otherProps = {
                        enableShiftSwapEmployeePreferences: false,
                        groupedShiftSwap: isAllowMultipleRequests,
                      }
                    }
                    this.setState(
                      {
                        isAllowProposalWithOffer: !isAllowProposalWithOffer,
                        ...otherProps,
                      },
                      () => this.submitableForm()
                    );
                  },
                  isAllowProposalWithOffer,
                  t("form.enabled"),
                  t("form.disabled"),
                  `${t("form.isAllowProposalWithOfferDisclaimer")} ${breRuleSet.isMultipleShiftOnSameDayRuleEnabled ? t('form.isAllowProposalWithOfferDisabledReason') : ""}`,
                  false,
                  "isAllowProposalWithOffer",
                  isDisabledEdit || (breRuleSet.isMultipleShiftOnSameDayRuleEnabled && isAllowMultipleRequests && !groupedShiftSwap) || (isKeepEmployeeWorkRule && isAllowMultipleRequests && !groupedShiftSwap),
                  getIsAllowProposalWithOfferTooltipOnDisabled(isDisabledEdit, breRuleSet.isMultipleShiftOnSameDayRuleEnabled && isAllowMultipleRequests && !groupedShiftSwap, isKeepEmployeeWorkRule && isAllowMultipleRequests && !groupedShiftSwap),
                )}
              </>
            )}
            <div className={classes.privateEmployeeSourceContainer}>
              {this.generateInputs(
                t("form.requestsRulesSection.privateEmployeeSource.label"),
                t(
                  "form.requestsRulesSection.privateEmployeeSource.placeholder"
                ),
                privateEmployeeSource,
                privateEmployeeSources,
                "privateEmployeeSource",
                false,
                t("form.requestsRulesSection.privateEmployeeSource.disclaimer"),
                <>{t("form.requestsRulesSection.privateEmployeeSource.toolTipParagraph1")} <br /> {t("form.requestsRulesSection.privateEmployeeSource.toolTipParagraph2")}</>
              )}
            </div>
            <div>
              <Typography className={classes.subHeader} color="textSecondary">{t('form.requestsRulesSection.AutoExpiryOptions.label')}</Typography>
              <ReactToggle
                ToggleFct={this.handleAutoExpiryOnPrivateOfferChange}
                labelOn={t("form.enabled")}
                labelOff={t("form.disabled")}
                note={null}
                toggleValue={isAutoExpiryTimeOnPrivateOfferEnabled}
                hidden={false}
                disabled={false}
                tooltipOnDisabled={null}
                key={'isAutoExpiryTimeOnPrivateOfferEnabled_' + isAutoExpiryTimeOnPrivateOfferEnabled}
                isDisclaimerShown={false}
              />
              {isAutoExpiryTimeOnPrivateOfferEnabled && (
                <>
                  <br />
                  <DurationInput
                    onChange={this.handleAutoExpiryTimeOnPrivateOfferChange}
                    value={autoExpiryTimeOnPrivateOffer}
                    size="small"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    disabled={false}
                    placeholder="hh:mm"
                  />
                </>
              )}
              <p>
                <small className={classes.note}>{"*" + t("form.requestsRulesSection.AutoExpiryOptions.disclaimer")}</small>
              </p>
            </div>
            {requestType === RequestTypes.shiftSwap && (
              <div className={classes.containerLabelsFullWidth}>
                <Typography className={classes.subHeader} color="textSecondary">
                  {t("form.isShiftSwapEmployeePreferencesTitle")}
                </Typography>
              </div>
            )}
            {this.generateToggle(
              () =>
                this.setState(
                  {
                    enableShiftSwapEmployeePreferences:
                      !enableShiftSwapEmployeePreferences,
                  },
                  () => this.submitableForm()
                ),
              enableShiftSwapEmployeePreferences,
              t("form.enabled"),
              t("form.disabled"),
              "",
              requestType === RequestTypes.toCover,
              "enableShiftSwapEmployeePreferences",
              isDisabledEdit || isAllowProposalWithOffer,
              getEnableShiftSwapEmployeePreferencesTooltipOnDisabled(isDisabledEdit, isAllowProposalWithOffer)
            )}
            {requestType === RequestTypes.shiftSwap && (
              <div>
                <div className={classes.containerLabelsFullWidth}>
                  <Typography
                    className={classes.subHeader}
                    color="textSecondary"
                  >
                    {t("form.isAllowMultipleRequests.label")}
                  </Typography>
                </div>
                {this.generateToggle(
                  () =>
                    this.setState({ isAllowMultipleRequests: !isAllowMultipleRequests, groupedShiftSwap: isAllowMultipleRequests ? false : isAllowProposalWithOffer }, () =>
                      this.submitableForm()
                    ),
                  isAllowMultipleRequests,
                  t("form.enabled"),
                  t("form.disabled"),
                  t("form.isAllowMultipleRequests.disclaimer"),
                  false,
                  "isAllowMultipleRequests",
                  isAllowProposalWithOffer && (breRuleSet.isMultipleShiftOnSameDayRuleEnabled || isKeepEmployeeWorkRule),
                  getIsAllowMultipleRequestsTooltipOnDisabled(breRuleSet.isMultipleShiftOnSameDayRuleEnabled, isKeepEmployeeWorkRule)
                )}
              </div>
            )}
            {requestType === RequestTypes.shiftSwap && isAllowMultipleRequests && (
              <div>
                Grouping options
                <hr />
                <div className={classes.containerLabelsFullWidth}>
                  <Typography
                    className={classes.subHeader}
                    color="textSecondary"
                  >
                    {t("form.groupedShiftSwap")}
                  </Typography>
                </div>
                {this.generateToggle(
                  () =>
                    this.setState({ groupedShiftSwap: !groupedShiftSwap }, () =>
                      this.submitableForm()
                    ),
                  groupedShiftSwap,
                  t("form.enabled"),
                  t("form.disabled"),
                  t("form.groupedShiftSwapDisclaimer"),
                  false,
                  "groupedShiftSwap",
                  isGroupedShiftSwapDisabled,
                  getGroupedShiftSwapTooltipOnDisabled(isDisabledEdit, isAllowProposalWithOffer, breRuleSet.isMultipleShiftOnSameDayRuleEnabled, isKeepEmployeeWorkRule),
                )}
              </div>
            )}
          </CardContent>
        );
      } else if (requestType === RequestTypes.voluntaryTimeOff) {
        cardContent = (
          <CardContent>
            {t("form.requestsRulesSection.vto.subheader")}
            <hr />
            <div className={classes.containerLabelsFullWidth}>
              <Typography className={classes.subHeader} color="textSecondary">
                {t(
                  "form.requestsRulesSection.vto.isAllowSignUpPeriodWithToCoverShift"
                )}
              </Typography>
            </div>
            {this.generateToggle(
              () =>
                this.setState(
                  {
                    isAllowSignUpPeriodWithToCoverShift:
                      !isAllowSignUpPeriodWithToCoverShift,
                  },
                  () => this.submitableForm()
                ),
              isAllowSignUpPeriodWithToCoverShift,
              t("form.enabled"),
              t("form.disabled"),
              "",
              false,
              "isAllowSignUpPeriodWithToCoverShift",
              isDisabledEdit
            )}
            <div className={classes.containerLabelsFullWidth}>
              <Typography className={classes.subHeader} color="textSecondary">
                {t(
                  "form.requestsRulesSection.vto.isAllowSignUpPeriodWithShiftSwapShift"
                )}
              </Typography>
            </div>
            {this.generateToggle(
              () =>
                this.setState(
                  {
                    isAllowSignUpPeriodWithShiftSwapShift:
                      !isAllowSignUpPeriodWithShiftSwapShift,
                  },
                  () => this.submitableForm()
                ),
              isAllowSignUpPeriodWithShiftSwapShift,
              t("form.enabled"),
              t("form.disabled"),
              "",
              false,
              "isAllowSignUpPeriodWithShiftSwapShift",
              isDisabledEdit
            )}
            <div className={classes.containerLabelsFullWidth}>
              <Typography className={classes.subHeader} color="textSecondary">
                {t(
                  "form.requestsRulesSection.vto.isAllowSignUpPeriodWithOpenShift"
                )}
              </Typography>
            </div>
            {this.generateToggle(
              () =>
                this.setState(
                  {
                    isAllowSignUpPeriodWithOpenShift:
                      !isAllowSignUpPeriodWithOpenShift,
                  },
                  () => this.submitableForm()
                ),
              isAllowSignUpPeriodWithOpenShift,
              t("form.enabled"),
              t("form.disabled"),
              "",
              false,
              "isAllowSignUpPeriodWithOpenShift",
              isDisabledEdit
            )}
          </CardContent>
        );
      }
      return (
        <Card className={classes.cards}>
          <CardHeader
            className={classes.cardHeader}
            color="textSecondary"
            gutterBottom
            avatar={<Avatar className={classes.avatar}>{index}</Avatar>}
            title={t("form.requestsRulesSection.header")}
          />
          {cardContent}
        </Card>
      );
    };

    const approvalSection = (index) => {
      const { isAllowMultipleRequests, groupedShiftSwap } = this.state;
      const breRuleSetListOptions = getBreRuleSetListOptions(breRuleSetList, actionType.value, isAllowMultipleRequests && groupedShiftSwap, requestSubtype);
      return (
        <Card className={classes.cards}>
          <CardHeader className={classes.cardHeader} color="textSecondary" gutterBottom avatar={<Avatar className={classes.avatar}>{index}</Avatar>} title={t('form.approvalTitle')} />
          <CardContent>
            {
              this.generateInputs(
                t('form.engineValidation.label'),
                t('form.engineValidation.placeholder'),
                breRuleSet,
                breRuleSetListOptions,
                'breRuleSet',
                isUsedAdminSetting,
              )
            }
            {
              this.generateToggle(
                () =>
                  this.setState({ autoApproval: !autoApproval }, () =>
                    this.submitableForm()
                  ),
                autoApproval,
                t('form.autoApproval'),
                t('form.manualApproval'),
                t('form.autoApprovalDisclaimer'),
                false,
                "autoApproval",
                isUsedAdminSetting,
              )
            }
            <TimeOffRequestWarning
              isOpen={isShowTimeOffRequestWarning}
              onOk={this.hideTimeOffRequestWarning.bind(this)}
            />
          </CardContent>
        </Card>
      )
    }

    const awardingSection = (index) => {
      const activeAwardingRules = awardingRulesList.filter((x) => x.isActive);
      return (
        <Card className={classes.cards}>
          <CardHeader
            className={classes.cardHeader}
            color="textSecondary"
            gutterBottom
            avatar={<Avatar className={classes.avatar}>{index}</Avatar>}
            title={t("form.awardingTitle")}
          />
          <CardContent>
            {this.generateInputs(
              t("form.awardingValidation"),
              "Select Awarding Rule Set",
              awardingRule,
              activeAwardingRules,
              "awardingRule",
              false
            )}
          </CardContent>
        </Card>
      );
    };

    const notificationSection = (index) => {
      let requestType = "";
      switch (actionType.value) {
        case RequestTypes.toCover:
          requestType = t("requestType.toCover");
          break;
        case RequestTypes.shiftSwap:
          requestType = t("requestType.shiftSwap");
          break;
        case RequestTypes.openShift:
          if (isRequestSubtypeSignUp) {
            requestType = t("requestType.requestSubtypes.openShift.signUp");
          }
          break;
        case RequestTypes.voluntaryTimeOff:
          requestType = t("requestType.voluntaryTimeOff");
          break;
        default:
          break;
      }

      return (
        <Card className={[classes.cards, classes.paddingCard].join(" ")}>
          <CardHeader
            className={classes.cardHeader}
            color="textSecondary"
            gutterBottom
            avatar={<Avatar className={classes.avatar}>{index}</Avatar>}
            title={t("form.notificationsTemp")}
          />
          <CustomTagsDisplay requestType={actionType.value} />
          <Card className={classes.cards}>
            <CardHeader
              className={classes.cardHeader}
              color="textSecondary"
              titleTypographyProps={{ variant: "h7" }}
              title={t("form.manager")}
            />
            <CardContent>
              {this.generateInputs(
                t("form.managerSubmitted"),
                t("form.selectTemplate"),
                template10,
                genericNotificationList,
                "template10",
                false
              )}
              {this.generateInputs(
                t("form.managerRetracted"),
                t("form.selectTemplate"),
                template13,
                genericNotificationList,
                "template13",
                false
              )}
              {this.generateInputs(
                t("form.commentSubmittedNotificationLabel"),
                t("form.selectTemplate"),
                template15,
                genericNotificationList,
                "template15",
                false
              )}
            </CardContent>
          </Card>
          <Card className={classes.cards}>
            <CardHeader
              className={classes.cardHeader}
              color="textSecondary"
              titleTypographyProps={{ variant: "h7" }}
              title={t("form.employee")}
            />
            <CardContent>
              {this.generateInputs(
                t("form.approvedStatus"),
                t("form.selectTemplate"),
                template1,
                genericNotificationList,
                "template1",
                false
              )}
              {this.generateInputs(
                t("form.rejectedStatus"),
                t("form.selectTemplate"),
                template2,
                genericNotificationList,
                "template2",
                false
              )}
              {!isOpenShift && !isVoluntaryTimeOff
                ? this.generateInputs(
                  t("form.requestedStatus"),
                  t("form.selectTemplate"),
                  template4,
                  genericNotificationList,
                  "template4",
                  false
                )
                : null}
              {this.generateInputs(
                t("form.pendingStatus"),
                t("form.selectTemplate"),
                template8,
                genericNotificationList,
                "template8",
                false
              )}
              {!isOpenShift && !isVoluntaryTimeOff
                ? this.generateInputs(
                  t("form.cancelRequestStatus"),
                  t("form.selectTemplate"),
                  template6,
                  genericNotificationList,
                  "template6",
                  false
                )
                : null}
              {isShiftSwap
                ? this.generateInputs(
                  t("form.proposedStatus"),
                  t("form.selectTemplate"),
                  template14,
                  genericNotificationList,
                  "template14",
                  false
                )
                : null}
              {isToCover || isShiftSwap
                ? this.generateInputs(
                  t("form.declinedStatus"),
                  t("form.selectTemplate"),
                  template12,
                  genericNotificationList,
                  "template12",
                  false
                )
                : null}
              {!isOpenShift && !isVoluntaryTimeOff
                ? this.generateInputs(
                  t("form.cancelOfferStatus"),
                  t("form.selectTemplate"),
                  template5,
                  genericNotificationList,
                  "template5",
                  false
                )
                : null}
              {!(isOpenShift && !isRequestSubtypeSignUp)
                ? this.generateInputs(
                  t("form.offeredStatus", { requestType }),
                  t("form.selectTemplate"),
                  template3,
                  genericNotificationList,
                  "template3",
                  false
                )
                : null}
              {!isOpenShift && !isVoluntaryTimeOff 
                ? this.generateInputs(
                 t("form.privateOfferedStatus", { requestType }),
                  t("form.selectTemplate"),
                template16,
                genericNotificationList,
                "template16",
                false
                ) : null}
              {!isOpenShift && !isVoluntaryTimeOff
                ? this.generateInputs(
                  t("form.offerExpired"),
                  t("form.selectTemplate"),
                  template7,
                  genericNotificationList,
                  "template7",
                  false
                )
                : null}
              {this.generateInputs(
                t("form.failToProcess"),
                t("form.selectTemplate"),
                template9,
                genericNotificationList,
                "template9",
                false
              )}
              {isShiftSwap
                ? this.generateInputs(
                  t("form.proposalExpired"),
                  t("form.selectTemplate"),
                  template11,
                  genericNotificationList,
                  "template11",
                  false
                )
                : null}
            </CardContent>
          </Card>
        </Card>
      );
    };

    const renderPartialShiftSection = (isVtoTimePeriodSelected = false) => {
      const {
        enablePartialShifts,
        multiplePartial,
        isAllowPartialOfPartial,
        minimumPartialShiftDuration,
        minimumPartialShiftBalanceDuration,
        isPartialOnlyOnEdges,
        isUsedAdminSetting,
        maxAllowedPartial,
      } = this.state;

      return (
        <PartialShiftSection
          classes={classes}
          isShow={true}
          isToCover={isToCover}
          isShiftSwap={isShiftSwap}
          isOpenShift={isOpenShift}
          isVoluntaryTimeOff={isVtoTimePeriodSelected}
          onChange={this.handleChangeTextfield}
          handleChangeEnablePartialShift={
            this.handleChangeEnablePartialShift
          }
          enablePartialShifts={enablePartialShifts}
          multiplePartial={multiplePartial}
          isAllowPartialOfPartial={isAllowPartialOfPartial}
          minimumPartialShiftDuration={minimumPartialShiftDuration}
          minimumPartialShiftBalanceDuration={
            minimumPartialShiftBalanceDuration
          }
          isPartialOnlyOnEdges={isPartialOnlyOnEdges}
          isUsedAdminSetting={isUsedAdminSetting}
          maxAllowedPartial={maxAllowedPartial}
        />
      );
    };

    const vtoTypesSection = (index) => {
      const {
        vtoTypes,
        vtoCoverageRequiredEdgesOptions,
        vtoCoverageRequiredEdgeSelected,
        timePeriodRatioOptions,
        isVtoOverlapChecked,
        vtoPaycodeCreationType,
        minimumShiftBalanceDuration,
      } = this.state;

      const countVtoTypes = vtoTypes.filter((type) => type.checked).length;
      const countRatioOptions = timePeriodRatioOptions.filter(
        (option) => option.checked
      ).length;

      return (
        <Card className={classes.cards}>
          <CardHeader
            className={classes.cardHeader}
            color="textSecondary"
            gutterBottom
            avatar={<Avatar className={classes.avatar}>{index}</Avatar>}
            title={t("form.vtoTypesAndCoverageTitle")}
          />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControl
                  component="fieldset"
                  className={classes.formControl}
                >
                  <FormLabel component="legend">
                    {t("form.vtoTypesTitle")}
                  </FormLabel>
                  <FormGroup>
                    {getVtoTypes(vtoTypes, requestSubtype).map((type) => {
                      return (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={type.checked}
                              color="primary"
                              onChange={(e) =>
                                this.handleCheckboxSelect(
                                  e.target.name,
                                  e.target.value
                                )
                              }
                              name={"vtoTypes"}
                              value={type.value}
                              disabled={isUsedAdminSetting}
                            />
                          }
                          label={t(`form.vtoTypes.${type.translation}`)}
                        />
                      );
                    })}
                  </FormGroup>
                </FormControl>
                {countVtoTypes === 0 ? (
                  <FormHelperText error>
                    At least 1 type must be selected
                  </FormHelperText>
                ) : null}
                {vtoTypes[2].checked && (
                  <RadioGroup
                    aria-label="vtoCoverageRequiredEdges"
                    name="vtoCoverageRequiredEdges"
                    value={vtoCoverageRequiredEdgeSelected}
                    disabled={isUsedAdminSetting}
                    onChange={(e) =>
                      this.setState(
                        {
                          vtoCoverageRequiredEdgeSelected: parseInt(
                            e.target.value
                          ),
                        },
                        () => this.submitableForm()
                      )
                    }
                  >
                    {vtoCoverageRequiredEdgesOptions.map((type) => (
                      <FormControlLabel
                        value={type.value}
                        control={<Radio color="primary" size="small" />}
                        label={type.label}
                        disabled={isUsedAdminSetting}
                      />
                    ))}
                  </RadioGroup>
                )}
              </Grid>
              {vtoTypes[2].checked ? (
                <Grid item xs={6}>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormLabel component="legend">
                      {t("form.coverageOptionsTitle")}
                    </FormLabel>
                    <FormGroup>
                      {timePeriodRatioOptions.map((type) => {
                        return (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={type.checked}
                                color="primary"
                                onChange={(e) =>
                                  this.handleCheckboxSelect(
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                                name={"timePeriodRatioOptions"}
                                value={type.value}
                                disabled={isUsedAdminSetting}
                              />
                            }
                            label={t(`form.coverageOptions.${type.name}`)}
                          />
                        );
                      })}
                    </FormGroup>
                  </FormControl>
                  {countRatioOptions === 0 ? (
                    <FormHelperText error>
                      At least 1 option must be selected
                    </FormHelperText>
                  ) : null}
                </Grid>
              ) : null}
              {vtoTypes[2].checked && (
                <Grid item xs={12} style={{ marginTop: '10px' }}>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                    style={{ width: '100%' }}
                  >
                    <FormLabel component="legend">
                      {t("form.vtoTruncationSetupTitle")}
                    </FormLabel>
                    <FormGroup>
                      <ReactSelect
                        labelText={t("form.requestsRulesSection.vto.vtoPaycodeCreationType.label")}
                        value={vtoPaycodeCreationType}
                        onChange={(target, selectedValue) => {
                          const newState = { vtoPaycodeCreationType: selectedValue };
                          // If changing away from Overlap, disable partial shifts
                          if (selectedValue?.value !== VtoPaycodeCreationType.Overlap) {
                            newState.enablePartialShifts = false;
                            newState.minimumPartialShiftDuration = 0;
                            newState.minimumPartialShiftBalanceDuration = 0;
                            newState.isPartialOnlyOnEdges = false;
                          }
                          this.setState(newState, () => this.submitableForm());
                        }}
                        target="vtoPaycodeCreationType"
                        options={getVtoPaycodeCreationTypeOptions()}
                        placeholder={t("form.requestsRulesSection.vto.vtoPaycodeCreationType.placeholder")}
                        isDisabled={isUsedAdminSetting}
                        isClearable={true}
                        helpIconText={t("form.requestsRulesSection.vto.vtoPaycodeCreationType.disclaimer")}
                      />
                    </FormGroup>
                    <FormGroup>
                      <FormControlLabel
                        className={classes.vtoCheckBox}
                        control={
                          <Checkbox
                            checked={isVtoOverlapChecked}
                            color="primary"
                            onChange={(e) =>
                              this.setState({
                                  isVtoOverlapChecked: e.target.checked,
                                  enablePartialShifts: false,
                                  minimumPartialShiftDuration: 0,
                                  isPartialOnlyOnEdges: false,
                                  minimumShiftBalanceDuration: 0,
                                }, () => this.submitableForm())
                            }
                            name={"vtoOverlap"}
                          />
                        }
                        label={t("form.requestsRulesSection.vto.isVtoOverlapChecked")}
                        disabled={isUsedAdminSetting}
                      />
                      <span><small className={classes.note}>{"*" + t("form.requestsRulesSection.vto.isVtoOverlapCheckedDisclaimer")}</small></span>
                    </FormGroup>
                    {isVtoOverlapChecked && (
                      <div style={{ paddingTop: '16px' }}>
                        <FormControl
                          component="fieldset"
                          className={classes.formControl}
                        >
                          <FormLabel component="legend">
                            {t("form.requestsRulesSection.vto.limits")}
                          </FormLabel>
                          <FormGroup>
                            <HoursMinutesPicker
                              nbHours={Math.floor(minimumShiftBalanceDuration / 60)}
                              nbMinutes={Math.abs(minimumShiftBalanceDuration) % 60}
                              minuteStep={15}
                              minuteMax={45}
                              handleChange={(hours, minutes) => this.handleChangeTextfield('minimumShiftBalanceDuration', hours * 60 + minutes)}
                              name="MinShiftBalanceDuration"
                              label={t("form.requestsRulesSection.vto.remainingShiftsDuration")}
                              smallLabels={true}
                              classes={classes}
                              hourFormat={(num) => {
                                if (num === 1) {
                                  return num + ' Hour';
                                }
                                else {
                                  return num + ' Hours';
                                }
                              }}
                              minuteFormat={(num) => {
                                if (num === 1) {
                                  return num + ' Minute';
                                }
                                else {
                                  return num + ' Minutes';
                                }
                              }}
                              style={HoursMinutesPickerStyles}
                            />
                          </FormGroup>
                        </FormControl>
                        {vtoPaycodeCreationType?.value == VtoPaycodeCreationType.Overlap && (
                          <div style={{ paddingTop: '16px' }}>
                            <FormControl
                              component="fieldset"
                              className={classes.formControl}
                            >
                              <FormLabel component="legend">
                                {t("form.vtoPartialSetupTitle")}
                              </FormLabel>
                              <FormGroup>
                                {renderPartialShiftSection(true)}
                              </FormGroup>
                            </FormControl>
                          </div>
                        )}
                      </div>
                    )}
                  </FormControl>
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Card>
      );
    };

    const content = () => {
      let stepIndex = 1;
      switch (actionType.value) {
        case RequestTypes.toCover:
          return (
            <>
              {informationSection(stepIndex++)}
              {displayAccessSection(stepIndex++)}
              {dataviewSection(stepIndex++)}
              {rulesSection(stepIndex++)}
              {requestsRulesSection(stepIndex++, RequestTypes.toCover)}
              {approvalSection(stepIndex++)}
              {notificationSection(stepIndex++)}
            </>
          );
        case RequestTypes.shiftSwap:
          return (
            <>
              {informationSection(stepIndex++)}
              {displayAccessSection(stepIndex++)}
              {dataviewSection(stepIndex++)}
              {rulesSection(stepIndex++)}
              {requestsRulesSection(stepIndex++, RequestTypes.shiftSwap)}
              {approvalSection(stepIndex++)}
              {notificationSection(stepIndex++)}
            </>
          );
        case RequestTypes.openShift:
          return (
            <>
              {informationSection(stepIndex++)}
              {displayAccessSection(stepIndex++)}
              {dataviewSection(stepIndex++)}
              {rulesSection(stepIndex++)}
              {approvalSection(stepIndex++)}
              {isRequestSubtypeSignUp ? awardingSection(stepIndex++) : null}
              {notificationSection(stepIndex++)}
            </>
          );
        case RequestTypes.voluntaryTimeOff:
          return (
            <>
              {informationSection(stepIndex++)}
              {displayAccessSection(stepIndex++)}
              {dataviewSection(stepIndex++)}
              {schedulingSection(stepIndex++)}
              {vtoTypesSection(stepIndex++)}
              {!!vtoTypes.find(
                (x) =>
                  x.checked &&
                  [
                    VoluntaryTimeOffType.SingleDay,
                    VoluntaryTimeOffType.TimePeriod,
                  ].includes(x.value)
              ) &&
                requestsRulesSection(
                  stepIndex++,
                  RequestTypes.voluntaryTimeOff
                )}
              {approvalSection(stepIndex++)}
              {isRequestSubtypeSignUp ? awardingSection(stepIndex++) : null}
              {notificationSection(stepIndex++)}
            </>
          );
        default:
          return <></>;
      }
    };

    return (
      <>
        <div className={containerClass.join(" ")}>{content()}</div>
        {action === AdminSidePanelActionNames.View ? (
          <div
            style={{
              display: "flex",
              padding: "14px",
              justifyContent: "flex-end",
            }}
          >
            <CustomButton
              onClick={cancel}
              variant="contained"
              color="secondary"
              size="medium"
            >
              {t("form.close")}
            </CustomButton>
          </div>
        ) : (
          <ActionButtons
            cancel={cancel}
            submit={this.submitForm}
            disabledSubmit={!isSubmitable}
            submitText={t("form.save")}
            cancelText={t("form.cancel")}
          />
        )}
      </>
    );
  }
}

export default withTranslation("employmentBillboard")(withStyles(styles)(Form));